/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupRecordingResponseExisting } from './LookupRecordingResponseExisting';
import {
    LookupRecordingResponseExistingFromJSON,
    LookupRecordingResponseExistingFromJSONTyped,
    LookupRecordingResponseExistingToJSON,
} from './LookupRecordingResponseExisting';

/**
 * 
 * @export
 * @interface LookupRecordingResponse
 */
export interface LookupRecordingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LookupRecordingResponse
     */
    checked: boolean;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponse
     */
    recordingId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LookupRecordingResponse
     */
    sameArtist: boolean;
    /**
     * 
     * @type {LookupRecordingResponseExisting}
     * @memberof LookupRecordingResponse
     */
    existing: LookupRecordingResponseExisting | null;
}

/**
 * Check if a given object implements the LookupRecordingResponse interface.
 */
export function instanceOfLookupRecordingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checked" in value;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "sameArtist" in value;
    isInstance = isInstance && "existing" in value;

    return isInstance;
}

export function LookupRecordingResponseFromJSON(json: any): LookupRecordingResponse {
    return LookupRecordingResponseFromJSONTyped(json, false);
}

export function LookupRecordingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checked': json['checked'],
        'recordingId': json['recordingId'],
        'sameArtist': json['sameArtist'],
        'existing': LookupRecordingResponseExistingFromJSON(json['existing']),
    };
}

export function LookupRecordingResponseToJSON(value?: LookupRecordingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checked': value.checked,
        'recordingId': value.recordingId,
        'sameArtist': value.sameArtist,
        'existing': LookupRecordingResponseExistingToJSON(value.existing),
    };
}

